import type {NetworkType} from 'src/v2/state/types';
import {isMobile} from 'src/utils/utils';

// Mobile-specific network restrictions for providers
const PROVIDER_TO_DISABLED_NETWORK_MAPPINGS: Record<
  string,
  {key: string; networkType: NetworkType}
> = {
  'Coinbase Wallet': {
    key: 'dynamic-mobile-coinbasesolana',
    networkType: 'solana',
  },
  MetaMask: {
    key: 'dynamic-mobile-metamasksol',
    networkType: 'solana',
  },
};

export const isNetworkDisabledForProvider = (
  provider: string,
  networkType: NetworkType,
  disabledWalletProviders: string[],
): boolean => {
  const isOnMobile = isMobile();

  // WalletConnect only supports EVM networks (always applies)
  if (provider === 'WalletConnect' && networkType !== 'evm') {
    return true;
  }

  // Mobile-specific restrictions
  if (isOnMobile) {
    const providerMapping = PROVIDER_TO_DISABLED_NETWORK_MAPPINGS[provider];

    if (
      providerMapping &&
      disabledWalletProviders.includes(providerMapping.key)
    ) {
      return networkType === providerMapping.networkType;
    }
  }

  // Default: no networks are disabled
  return false;
};
